import { useState, useImperativeHandle } from 'react';

/**
 * Универсальный хук для управления табами по имени с поддержкой ref.
 * @param {Array<{name: string, label: string}>} tabs - массив табов с именами
 * @param {string} initialTabName - имя таба по умолчанию
 * @param {React.Ref} ref - ref для управления табами снаружи
 * @returns {[string, function]} - [текущее имя таба, функция для смены]
 */
export function useNamedTabs(tabs, initialTabName, ref) {
  const [tabName, setTabName] = useState(initialTabName);

  useImperativeHandle(
    ref,
    () => ({
      setTab: (name) => {
        if (tabs.some((tab) => tab.name === name)) setTabName(name);
      },
      getTab: () => tabName,
    }),
    [tabs, tabName]
  );

  return [tabName, setTabName];
}
